import clsx from "clsx"
import { KTSVG } from "../../../../../_metronic/helpers"

export function getHeader(header: string, isRequired:boolean) {
    return <h4 className='p-2 text-gray-800 fw-bolder mt-10 bg-light-primary rounded border'>
        {header}{isRequired && <span className="text-danger">*</span>}
    </h4>
}

export function getFormikSingleBlock(header: string, props: any, touched: any, errors: any, isRequired: boolean) {
    return <>
        <div className='fv-row mb-7'>
            {getHeader(header, isRequired)}
            <input
                placeholder=''
                type='text'
                autoComplete='off'
                {...props}
                className={clsx(
                    'form-control',
                    { 'is-invalid': touched && errors },
                    {
                        'is-valid': touched && !errors,
                    }
                )}
            />
            {touched && errors && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                        <span role='alert'>{errors}</span>
                    </div>
                </div>
            )}
        </div>
    </>
}

export function getFormikSingleTextAreaBlock(header: string, props: any, touched: any, errors: any, isRequired:boolean) {
    return <>
        <div className='fv-row mb-7'>
            {getHeader(header, isRequired)}
            <textarea
                rows={4}
                placeholder=''
                autoComplete='off'
                {...props}
                className={clsx(
                    'form-control',
                    { 'is-invalid': touched && errors },
                    {
                        'is-valid': touched && !errors,
                    }
                )}
            />
            {touched && errors && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                        <span role='alert'>{errors}</span>
                    </div>
                </div>
            )}
        </div>
    </>
}

export function getDoubleBlockFormik(header: string, props1: any, touched1: any, errors1: any, props2: any, touched2: any, errors2: any, isRequired:boolean) {
    return <>
        {getHeader(header, isRequired)}
        <div className='notice rounded border-primary border border-dashed ps-2 pe-2'>
            <div className='d-flex w-100 mt-3'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    TH
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        placeholder=''
                        type='text'
                        autoComplete='off'
                        {...props1}
                        className={clsx(
                            'form-control',
                            { 'is-invalid': touched1 && errors1 },
                            {
                                'is-valid': touched1 && !errors1,
                            }
                        )}
                    />
                    {touched1 && errors1 && (
                        <div className='ms-2'>
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{errors1}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='d-flex w-100 mb-2 mt-4'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    EN
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        placeholder=''
                        type='text'
                        autoComplete='off'
                        {...props2}
                        className={clsx(
                            'form-control',
                            { 'is-invalid': touched2 && errors2 },
                            {
                                'is-valid': touched2 && !errors2,
                            }
                        )}
                    />
                    {touched2 && errors2 && (
                        <div className='ms-2'>
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{errors2}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
}

export function getTextAreaDoubleBlockFormik(header: string, props1: any, touched1: any, errors1: any, props2: any, touched2: any, errors2: any, isRequired:boolean) {
    return <>
        {getHeader(header, isRequired)}
        <div className='notice rounded border-primary border border-dashed ps-2 pe-2'>
            <div className='d-flex w-100 mt-3'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    TH
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <textarea
                        placeholder=''
                        rows={5}
                        autoComplete='off'
                        {...props1}
                        className={clsx(
                            'form-control',
                            { 'is-invalid': touched1 && errors1 },
                            {
                                'is-valid': touched1 && !errors1,
                            }
                        )}
                    />
                    {touched1 && errors1 && (
                        <div className='ms-2'>
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{errors1}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='d-flex w-100 mb-2 mt-4'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    EN
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <textarea
                        placeholder=''
                        rows={5}
                        autoComplete='off'
                        {...props2}
                        className={clsx(
                            'form-control',
                            { 'is-invalid': touched2 && errors2 },
                            {
                                'is-valid': touched2 && !errors2,
                            }
                        )}
                    />
                    {touched2 && errors2 && (
                        <div className='ms-2'>
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{errors2}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
}

export function getSingleBlock(header: string, text: string, isRequired:boolean) {
    return <>
        <div className='fs-4 fw-normal text-gray-800 mb-10 mt-10'>
            {getHeader(header, isRequired)}
            <input
                type="text"
                className="form-control"
            />
        </div>
    </>
}

export function getDoubleBlock(header: string, th_string: string, en_string: string, isRequired:boolean) {
    return <>
        {getHeader(header, isRequired)}
        <div className='notice rounded border-primary border border-dashed ps-2 pe-2'>
            <div className='d-flex w-100 mt-3'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    TH
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>

            <div className='d-flex w-100 mb-2 mt-4'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    EN
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
    </>
}